import React from 'react';
import createReactClass from 'create-react-class';
import postal from 'postal';

const AjaxInProgressHOC = function (Component) {
  const AjaxInProgressComponent = createReactClass({
    displayName: 'AjaxInProgressHOC',

    getInitialState() {
      return {
        isAjaxInProgress : false
      };
    },

    componentWillMount() {
      const ajaxChannel = postal.channel('ajax');

      this.ajaxBeginSubscription = ajaxChannel.subscribe('ajax.begin', () => {
        this.setState({
          isAjaxInProgress: true
        });
      });

      this.ajaxEndSubscription = ajaxChannel.subscribe('ajax.end', () => {
        this.setState({
          isAjaxInProgress: false
        });
      });
    },

    componentWillUnmount() {
      if(this.ajaxBeginSubscription) {
        this.ajaxBeginSubscription.unsubscribe();
        this.ajaxBeginSubscription = null;
      }

      if(this.ajaxEndSubscription) {
        this.ajaxEndSubscription.unsubscribe();
        this.ajaxEndSubscription = null;
      }
    },

    render() {
      return <Component {...this.props} isAjaxInProgress={this.state.isAjaxInProgress} />;
    }

  });

  return AjaxInProgressComponent;
};

export default AjaxInProgressHOC;



// WEBPACK FOOTER //
// ./src/components/common/AjaxInProgressHOC.js